<template>
  <form @submit.prevent="submit" class="flex flex-col gap-8">
    <div class="pz-form-group">
      <div class="flex justify-between py-2">
        <span class="pz-label">
          <span v-if="showLabel">Impression <span class="text-error">*</span></span>
        </span>
      </div>
      <textarea
        v-model="text"
        placeholder="Enter patient impressions (e.g. Patient is in severe stress and has lumpy eyes)"
        class="h-[64px] pz-textarea"
        required
        :disabled="loading"
      ></textarea>
    </div>
    <div class="flex gap-4 justify-end">
      <button
        v-if="formSubmittable"
        type="button"
        class="pz-btn-outlined btn-sm normal-case"
        @click="resetForm"
      >
        Clear All
      </button>
      <button
        type="submit"
        class="pz-btn-filled btn-sm normal-case text-white"
        :disabled="!formSubmittable"
      >
        {{ isEditing ? 'Save Changes' : 'Submit' }}
      </button>
    </div>
  </form>
</template>

<script>
import { computed, ref } from 'vue';
import { useImpressions } from './composables';

export default {
  props: {
    showLabel: Boolean,
  },
  setup (props, { emit }) {
    const { submit: submitImpression } = useImpressions();

    const loading = ref(false);
    const record = ref({});
    const recordId = computed(() => record.value.id);
    const isEditing = computed(() => !!recordId.value);

    const text = ref('');

    const formSubmittable = computed(() => {
      return !!text.value;
    });

    const submit = async () => {
      try {
        loading.value = true;

        const payload = {
          text: text.value,
        };

        // Update
        if (isEditing.value) {
          payload.id = recordId.value;
        }

        await submitImpression(payload);

        resetForm();
        emit('submit');
        emit('success');
      } catch (e) {
        console.error('Something went wrong. Try again later.');
        emit('error', e);
      } finally {
        loading.value = false;
      }
    };

    function resetForm () {
      record.value = {};
      text.value = '';
    }

    // Sets value to record for editing purposes
    // as well as set value model.text
    function setForm (data) {
      if (!data) return;
      record.value = data;
      text.value = data.text;
    }

    return {
      loading,
      recordId,
      isEditing,
      text,
      formSubmittable,
      resetForm,
      submit,
      setForm,
    };
  },
};
</script>
